const X_AXIS_LABEL_CHAR_LIMIT = 15;

export function truncateChartAxisLabel(value: string | number): string {
  const label = String(value ?? "").trim();

  if (label.length <= X_AXIS_LABEL_CHAR_LIMIT) {
    return label;
  }

  return `${label.slice(0, X_AXIS_LABEL_CHAR_LIMIT)}....`;
}
